// src/App.tsx
import AppRoutes from "@/app/AppRoutes";
import { CommandPalette } from "@/components/CommandPalette";
import { ClientProvider } from "@/context/ClientContext";
import { ModeProvider } from "@/context/ModeContext";
import { NotificationsProvider } from "@/context/notifications/NotificationsContext";
import { ScopeProvider } from "@/context/ScopeContext";

const App: React.FC = () => {
  return (
    <NotificationsProvider>
      <ClientProvider>
        <ScopeProvider>
          <ModeProvider>
            <CommandPalette />
            <AppRoutes />
          </ModeProvider>
        </ScopeProvider>
      </ClientProvider>
    </NotificationsProvider>
  );
};

export default App;
